import './index.less';

import * as React from 'react';
import { findDOMNode } from 'react-dom';
import { Scrollbar, Collapse } from '@beehive/components';
import _ from 'lodash';
import { element } from 'utils';
import BaseInfo from './BaseInfo';
import SettleInfo from './SettleInfo';
import PlanInfo from './PlanInfo';
// import DescInfo from './DescInfo';
import TimeInfo from './TimeInfo';
import PayInfo from './payInfo';
import Bottom from './Bottom';
import PropTypes from 'prop-types';
import messages from 'messages/Workbench/ProjectDetail';
import StatementAttachmentItem from '@mpc/common/src/features/StatementAttachmentItem';
import ContractInformation from './ContractInfo';

export interface DetailProps {
  prefixCls: string;
  getBottomTabElement?: any;
  baseInfoProps?: any;
  planInfoConfig?: any;
  settleInfoConfig?: any;
  readOnly?: boolean;
}

const bodyRef: React.RefObject<HTMLDivElement> = React.createRef();
const bottomRef: React.RefObject<Bottom> = React.createRef();
let debounceResizeListener: EventListenerObject;

class Detail extends React.Component<DetailProps, any> {
  public static contextTypes = {
    intl: PropTypes.object,
    account: PropTypes.object,
    menuKey: PropTypes.string,
    detail: PropTypes.object,
    detailLoading: PropTypes.bool,
  };

  public componentDidMount() {
    // @ts-ignore
    debounceResizeListener = _.debounce(this.setBodyHeight, 100);
    window.addEventListener('resize', debounceResizeListener);
  }

  public componentDidUpdate() {
    this.setBodyHeight();
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', debounceResizeListener);
  }

  private setBodyHeight = (firstMount?: boolean) => {
    if (bodyRef.current && bottomRef.current) {
      const bodyDom = findDOMNode(bodyRef.current);
      const bottomDom = findDOMNode(bottomRef.current);

      const scrollPartSelector =
        '.sm-project-detail-show-detail-bottom-tab-content-wrapper-scroll-part';
      let bottomDomHeight = 0;
      let bottomDomMaxHeight: string | number = 0;
      if (bottomDom instanceof HTMLElement) {
        bottomDomHeight = bottomDom.clientHeight;
        // bottom最大高度
        bottomDomMaxHeight = +element
          .getStyle(bottomDom, 'max-height')
          .replace('px', '');
      }

      if (bodyDom instanceof HTMLElement) {
        const maxHeight =
          window.innerHeight -
          bodyDom.getBoundingClientRect().top -
          bottomDomHeight;
        bodyDom.style.height = maxHeight + 'px';
      }

      //  scroll part
      const activeTabpaneClass = `div.beehive-tabs-tabpane-active`;
      const bottomScrollDom: HTMLElement | null = document.querySelector(
        `${activeTabpaneClass} ${scrollPartSelector}`,
      );
      const bottomScrollBrothers = document.querySelectorAll(
        `${activeTabpaneClass} ${scrollPartSelector} ~ *`,
      );
      let feetHeight = 0;
      for (let i = 0; i < bottomScrollBrothers.length; i++) {
        feetHeight += element.getOuterHeight(
          bottomScrollBrothers[i] as HTMLElement,
        );
      }
      if (bottomScrollDom) {
        // extraHeight是tabs顶部和底部button的高度，24是底部padding的高度
        const extraHeight = feetHeight + bottomScrollDom.offsetTop + 24;
        // 第一次加载scrollbar需要撑到最大高度，之后根据bottom的实际高度来设置
        bottomDomMaxHeight =
          firstMount === true
            ? bottomDomMaxHeight || bottomDomHeight
            : bottomDomHeight;
        const scrollMaxHeight =
          bottomDomMaxHeight > extraHeight
            ? bottomDomMaxHeight - extraHeight
            : 0;
        bottomScrollDom.style.maxHeight = scrollMaxHeight + 'px';
        if (bottomScrollDom.firstElementChild instanceof HTMLElement) {
          // 6是scrollbar组件中滚动条的高度
          bottomScrollDom.firstElementChild.style.maxHeight =
            scrollMaxHeight + 6 + 'px';
        }
      }
    }
  }

  public render() {
    const { account, intl, menuKey, detail, detailLoading } = this.context;
    const {
      prefixCls,
      getBottomTabElement,
      baseInfoProps,
      planInfoConfig,
      settleInfoConfig,
      readOnly = true,
    } = this.props;

    if (!detail || detailLoading) {
      return null;
    }

    const className = `${prefixCls}-detail`;
    const { suppliersList = [] } = account || {};
    const { project_plan_info: planInfo = {}, project_suppliers = [], state = '', non_need_fee_control_verify } = detail;
    let showSettleInfo = false;
    let showPayInfo = false;
    let showStatementAttachment = false;

    if (menuKey) {
      showSettleInfo = !['pendingQuote', 'myAdvance'].includes(menuKey);
      showStatementAttachment = !['pendingQuote', 'confirmQuote'].includes(menuKey)
      showPayInfo = menuKey === 'myAdvance';
    } else {
      const paySupplierId = project_suppliers.length > 0 ? project_suppliers[0].supplier_id : '';
      const hasPaySupplier = !!(suppliersList || []).find((sp: any) => sp.id === paySupplierId);
      showSettleInfo = !['pending_quote'].includes(state);
      showPayInfo = hasPaySupplier;
      showStatementAttachment = !['pending_quote', 'business_audit_quote'].includes(state)
    }

    // if (detail?.demand_suppliers?.[0]?.inner_supplier) {
    //   showStatementAttachment = false
    // }

    return (
      <React.Fragment>
        <Scrollbar ref={bodyRef}>
          <div className={className}>
            <Collapse
              defaultActiveKey={['1']}
              className={`${className}-base-info`}
            >
              <Collapse.Panel
                header={intl.formatMessage(messages['panelKeys.baseInfo'])}
                key="1"
              >
                <BaseInfo {...baseInfoProps} prefixCls={className} />
              </Collapse.Panel>
            </Collapse>
            {showSettleInfo && (
              <Collapse
                defaultActiveKey={['1']}
                className={`${className}-settle-info`}
              >
                <Collapse.Panel
                  header={intl.formatMessage(messages['panelKeys.settleInfo'])}
                  key="1"
                >
                  <SettleInfo
                    prefixCls={className}
                    settleInfoConfig={settleInfoConfig}
                  />
                </Collapse.Panel>
              </Collapse>
            )}
            {showStatementAttachment && !non_need_fee_control_verify && (
              <Collapse
                defaultActiveKey={['1']}
              >
                <Collapse.Panel
                  header={'合同及付款信息'}
                  key="1"
                >
                  <ContractInformation detail={detail} />
                  <StatementAttachmentItem
                    value={{
                      invoice_belong_area: detail.invoice_belong_area,
                      is_oversea_invoice: detail.is_oversea_invoice,
                      invoice_list: detail.invoice_list,
                      signed_statement_attachs: detail.signed_statement_attachs,
                    }}
                    view={true}
                    detail={detail}
                  />
                </Collapse.Panel>
              </Collapse>
            )}
            {Object.keys(planInfo).length !== 0 ? (
              <Collapse
                defaultActiveKey={['1']}
                className={`${className}-plan-info`}
              >
                <Collapse.Panel
                  header={intl.formatMessage(messages['panelKeys.planInfo'])}
                  key="1"
                >
                  <PlanInfo
                    prefixCls={className}
                    planInfoConfig={planInfoConfig}
                    inPlanning
                  />
                </Collapse.Panel>
              </Collapse>
            ) : null}
            {showPayInfo ? (
              <Collapse
                defaultActiveKey={['1']}
                className={`${className}-pay-info`}
              >
                <Collapse.Panel
                  header={intl.formatMessage(messages['panelKeys.payInfo'])}
                  key="1"
                >
                  <PayInfo prefixCls={className} />
                </Collapse.Panel>
              </Collapse>
            ) : null}
            {/* <Collapse
              defaultActiveKey={['1']}
              className={`${className}-desc-info`}
            >
              <Collapse.Panel
                header={intl.formatMessage(messages['panelKeys.descInfo'])}
                key="1"
              >
                <DescInfo prefixCls={className} />
              </Collapse.Panel>
            </Collapse> */}
            <Collapse
              defaultActiveKey={['1']}
              className={`${className}-time-info`}
            >
              <Collapse.Panel
                header={intl.formatMessage(messages['panelKeys.timeGannt'])}
                key="1"
              >
                <TimeInfo prefixCls={className} />
              </Collapse.Panel>
            </Collapse>
          </div>
        </Scrollbar>
        {!readOnly && (
          <Bottom
            ref={bottomRef}
            prefixCls={className}
            onResize={this.setBodyHeight}
            getBottomTabElement={getBottomTabElement}
          />
        )}
      </React.Fragment>
    );
  }
}

export default Detail;
